export enum Status {
  Failed = 'failed',
  Init = 'initial',
  Loaded = 'loaded',
  Loading = 'loading',
}
